import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

interface DealData {
  name: string;
  discount: string;
  points: number;
  description: string;
  image: string;
  dateTo: string;
  restaurantLink?: string;
  output?: string;
  conditions?: string;
}

@Component({
  selector: 'app-deals-offer',
  templateUrl: './deals-offer.component.html',
  styleUrls: ['./deals-offer.component.scss']
})
export class DealsOfferComponent {
  @Input() focused = false;
  @Input() type: string;
  @Input() dealText: string;
  @Input() dealInfo: string;
  @Input() timeFrom: string;
  @Input() timeTo: string;
  @Input() imageSrc: string;
  @Input() date: string;
  @Input() newsText: string;
  @Input() newsInfo: string;
  @Input() buttons: string[];
  @Input() indexOfDeal: number;
  @Input() dealData: DealData;
  @Input() branchId: number;
  @Input() dateTo: string;
  get cssClass(): string {
    return this.type === 'deal' ? 'btn-chips btn-blue-light' : 'btn-chips btn-success-light';
  }

  get time(): string {
    return this.timeFrom != null && this.timeTo != null ? this.timeFrom + ' - ' + this.timeTo : '';
  }

  constructor(private modalService: NgbModal, private router: Router, private toastr: ToastrService) { }

  openModal(content: any) {
    this.modalService.open(content, {
      backdropClass: 'custom-backdrop',
      windowClass: 'custom-modal custom-coupon-modal',
      centered: true
    });
  }

  getTemplateByIndex(index: number, content1: any, content2: any, content3: any): any {
    // Use modulo to cycle through the templates
    const templateIndex = (index % 3);
    switch (templateIndex) {
      case 0:
        return content1;
      case 1:
        return content2;
      case 2:
        return content3;
      default:
        return content1;
    }
  }

  navigateToRestaurant = () => {
    if (this.branchId) {
      this.router.navigate(['business-detail', this.branchId]);
      this.modalService.dismissAll();
    } else {
      this.toastr.error("Restaurant Details are not available for navigation for this record!");
    }
  }
}
